import src from "IMAGE";
export default { src, width: 101, height: 90, blurWidth: 0, blurHeight: 0};
